import {Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {ApplicationFlowNavigator} from './application-flow.navigator';
import {LoanApplicationFlowSteps} from './steps/loan-application-flow.steps';

@Injectable()
export class LoanApplicationFlowNavigator extends ApplicationFlowNavigator {
    constructor(applicationFlowSteps: LoanApplicationFlowSteps, router: Router) {
        super(applicationFlowSteps, router);
    }
}